/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Musicology15Inputs */

const en__field_enum_study_musicology15 = /** @type {(inputs: _Field_Enum_Study_Musicology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musicology`)
};

const de__field_enum_study_musicology15 = /** @type {(inputs: _Field_Enum_Study_Musicology15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musikwissenschaft`)
};

/**
* | output |
* | --- |
* | "Musicology" |
*
* @param {_Field_Enum_Study_Musicology15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_musicology15 = /** @type {((inputs?: _Field_Enum_Study_Musicology15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Musicology15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_musicology15(inputs)
	return de__field_enum_study_musicology15(inputs)
});
export { _field_enum_study_musicology15 as "_field_enum_STUDY_MUSICOLOGY" }